export const campaignSlides = [
  {
    id: 'original', title: 'EMPRESS OF WELLNESS 2026',
    src: '/images/wellness-campaign-sportswear-suits-20260907-2060.webp', width: 2060, height: 763,
    srcSet: '/images/wellness-campaign-sportswear-suits-20260907-800.webp 800w, /images/wellness-campaign-sportswear-suits-20260907-1280.webp 1280w, /images/wellness-campaign-sportswear-suits-20260907-2060.webp 2060w',
    alt: 'ภาพประกอบผู้หญิงวัย 35+ ห้าคน ใส่ชุดกีฬา 3 คนและชุดสูทสีงาช้าง 2 คน บนฉากเขียวเข้มผสมแดงและทอง สำหรับแนวคิด EMPRESS OF WELLNESS',
  },
  {
    id: 'community', title: 'A stage for women 35+ · To care, grow, and shine again',
    src: '/images/wellness-campaign-community-wide-2060.webp', width: 2060, height: 763,
    srcSet: '/images/wellness-campaign-community-wide-800.webp 800w, /images/wellness-campaign-community-wide-1280.webp 1280w, /images/wellness-campaign-community-wide-2060.webp 2060w',
    alt: 'ภาพประกอบผู้หญิงห้าคนในชุดออกกำลังกาย พร้อมโลโก้ EMPRESS OF WELLNESS 2026 และข้อความ A STAGE FOR WOMEN 35+ · TO CARE, GROW, AND SHINE AGAIN · Wellness, Confidence, Leadership, Growth',
  },
]

export const campaignInterval = 6500

export function campaignIndex(index: number) {
  return ((index % campaignSlides.length) + campaignSlides.length) % campaignSlides.length
}

export function campaignSwipe(dx: number, dy: number) {
  if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return 0
  return dx < 0 ? 1 : -1
}

export function campaignCanPlay(state: {
  playing: boolean; hovered: boolean; visible: boolean; pageVisible: boolean
  reducedMotion: boolean; interacting: boolean; imagesReady: boolean
}) {
  return state.playing && !state.hovered && state.visible && state.pageVisible
    && !state.reducedMotion && !state.interacting && state.imagesReady
}
